<template>
  <div
    class  = "ln-dp__select d-flex flex-wrap"
    @click = "toShowDropdown"
    ref    = "selectorRef"
  >
    <div
      v-for  = "(selectOpt, i) in selectedOptions"
      class  = "ln-dp__select-value mr-2 me-2"
      :key   = "`selectOpt-${i}`"
    >
      <div class="d-flex align-items-center" style="padding: .125rem;">
        <div class="mr-1">{{ selectOpt.label }}</div>
        <b-icon icon="x-circle" @click.stop="removeOption(selectOpt.value)"></b-icon>
      </div>
    </div>

    <div v-if="selectedOptions.length < 1">
      {{ placeholder }}
    </div>

    <!-- dropdown -->
    <div
      class  = "ln-dp__content"
      :class = "{'ln-dp__content--active': showDropdown}"
      ref    = "dropdownRef"
    >
      <div class="ln-dp__search-bar">
        <input type="text" class="form-control" :placeholder="searchPlaceholder" v-model="searchString">
      </div>

      <!-- options -->
      <div
        class       = "ln-dp__option"
        v-for       = "(opt, idx) in selectOptions"
        @click.stop = "optionSelect(opt.value)"
        :key        = "`opt-${idx}`"
      >
        <!-- option info -->
        <div
          class = "d-flex align-items-center"
          style = "width: 43%;"
        >
          <div class="me-2">
            <div>{{ opt.label }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MulSelector',
  data () {
    return {
      searchString: '',
      showDropdown: false
    }
  },
  props: {
    options: Array,
    value: Array,
    placeholder: String,
    searchPlaceholder: String
  },
  watch: {
    options () {
      this.$emit('input', this.selectedValues)
    }
  },
  methods: {
    removeOption (v) {
      var tmp = this.value.filter((e) => {
        return e !== v
      })

      this.$emit('input', tmp)
    },
    optionSelect (v) {
      this.showDropdown = false
      this.searchString = ''

      this.$emit('input', [...this.value, v])
    },
    toShowDropdown () {
      this.showDropdown = true
    },
    handleClickOutside (event) {
      const selector = this.$refs.selectorRef
      if (selector && selector.contains(event.target)) {
        return
      }

      const dropdown = this.$refs.dropdownRef
      if (dropdown && !dropdown.contains(event.target)) {
        this.showDropdown = false
      }
    }
  },
  computed: {
    selectedOptions () {
      return this.options.filter((e) => {
        return this.value.indexOf(e.value) !== -1
      })
    },
    selectedValues () {
      return this.selectedOptions.map((e) => {
        return e.value
      })
    },
    selectOptions () {
      var opts = this.options

      if (this.searchString !== '') {
        const regex = new RegExp(this.searchString, 'i')
        opts = opts.filter((opt) => regex.test(opt.label))
      }

      opts = opts.filter((e) => {
        return this.selectedValues.indexOf(e.value) === -1
      })

      return opts
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style>
.lst-order-title {
  overflow: visible;
}
</style>
